<template>
  <div class="time-range-setting">
    <BaseElForm>
      <BaseElFormItem :label="displayText.unitPerPage">
        <BaseElSelect v-model="formData.unitPerPage">
          <BaseElSelectOption
            v-for="time in unitOptions"
            :key="time"
            :label="time"
            :value="time"
          />
        </BaseElSelect>
      </BaseElFormItem>
      <BaseElFormItem :label="displayText.columnHeight">
        <BaseElSelect v-model="formData.columnHeight">
          <BaseElSelectOption
            v-for="time in heightOptions"
            :key="time"
            :label="time"
            :value="time"
          />
        </BaseElSelect>
      </BaseElFormItem>
      <BaseElFormItem :label="displayText.displayItem">
        <BaseElSelect v-model="formData.displayItem" multiple clearable>
          <BaseElSelectOption
            v-for="item in contentOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </BaseElSelect>
      </BaseElFormItem>
      <BaseElFormItem :label="displayText.textSize">
        <BaseElSelect v-model="formData.textSize">
          <BaseElSelectOption
            v-for="time in textSizeOptions"
            :key="time"
            :label="time"
            :value="time"
          />
        </BaseElSelect>
      </BaseElFormItem>
    </BaseElForm>
  </div>
</template>

<script>
import { defineComponent, computed, onMounted, set } from 'vue'
import { useStorage } from '@vueuse/core'
import { isEmpty, get } from 'lodash'
import { generateNumbers } from '@/utils/helper'
import { t } from '@/plugins/i18n/i18n'

export default defineComponent({
  name: 'DisplaySetting',
  props: {
    length: {
      type: Number,
      default: 0,
    },
    storageKey: {
      type: String,
      default: 'dailyViewSettings',
    },
    extraContentOptions: {
      type: Array,
      default: () => [],
    },
  },
  setup (props, { emit }) {
    const formData = useStorage(props.storageKey, {
      unitPerPage: 10,
      columnHeight: 180,
      textSize: 12,
      displayItem: ['phone', 'name', 'birthday', 'reservationTime', 'serviceName'],
    })
    const displayText = computed(() => {
      const data = {
        unitPerPage: t('dailyView.display.unitPerPage'),
        columnHeight: t('dailyView.display.columnHeight'),
        textSize: t('dailyView.display.textSize'),
        displayItem: t('dailyView.display.displayItem'),
      }
      return data
    })
    const contentOptions = computed(() => {
      return [
        { label: t('dailyView.display.phone'), value: 'phone' },
        { label: t('dailyView.display.name'), value: 'name' },
        { label: t('dailyView.display.birthday'), value: 'birthday' },
        { label: t('dailyView.display.reservationTime'), value: 'reservationTime' },
        { label: t('dailyView.display.serviceName'), value: 'serviceName' },
        ...props.extraContentOptions,
      ]
    })
    const unitOptions = computed(() => {
      const maxLength = props.length < 10 ? props.length : 10
      return Array.from({ length: maxLength }, (_, index) => index + 1)
    })

    const heightOptions = computed(() => {
      return Array.from({ length: 19 }, (_, index) => (index + 2) * 20)
    })
    const textSizeOptions = computed(() => {
      return generateNumbers(12, 31, 1)
    })

    const onConfirm = () => {
      emit('confirm', formData)
      emit('close')
    }
    onMounted(() => {
      if (!get(formData.value, 'unitPerPage')) set(formData.value, 'unitPerPage', 5)
      if (!get(formData.value, 'columnHeight')) set(formData.value, 'columnHeight', 180)
      if (!get(formData.value, 'displayItem') || isEmpty(get(formData.value, 'displayItem'))) set(formData.value, 'displayItem', ['phone', 'name', 'birthday', 'reservationTime', 'serviceName'])
    })
    return {
      formData,
      onConfirm,
      unitOptions,
      heightOptions,
      contentOptions,
      textSizeOptions,
      displayText,
    }
  },
})
</script>

<style lang="postcss" scoped>
:deep(.el-input) {
  @apply h-full;
}
:deep(.el-select) {
  @apply h-full;
}
</style>
